export default class RandomImage {
    constructor(element) {
        this.element = element;
        this.count = ("count" in this.element.dataset) ? parseInt(this.element.dataset.count) : 1;
        this.images = this.element.querySelectorAll('[data-image]');
        this.init();
    }

    init() {
        // Remove "active" classes on elements
        for(let i = 0;i<this.images.length;i++)
            this.images[i].classList.remove("active");

        // Add "active" class to a random element
        const availableImages = [...this.images];

        let currentCount = 0;
        while (currentCount < this.count && availableImages.length > 0){
            const randomIndex = Math.floor(Math.random() * availableImages.length);
            availableImages[randomIndex].classList.add("active");
            availableImages.splice(randomIndex, 1);
            currentCount++;
        }
    }
}